import { useMutation, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

// our axios
import axiosInstance from 'services/API/API';

// Our Endpoints
import { getUserLiabilitiesUrl as saveStudentLiabilityURL } from 'shared/api-urls';

// Our Routes
import { IDENTIFIED_LIABILITIES_ROUTE } from 'routes';

// Our query keys
import { USER_LIABILITIES, WALLET_OVERVIEW_DATA } from 'shared/query-keys';

function useMutateSaveStudentLiability() {
	const navigate = useNavigate();
	const { tradeLineId } = useParams();

	const queryClient = useQueryClient();

	const urlForRequest = `${saveStudentLiabilityURL}${tradeLineId}`;

	return useMutation(
		async (studentLiabilityData) => {
			// is not a manual entry
			const response = await axiosInstance.patch(
				urlForRequest,
				studentLiabilityData
			);

			await queryClient.invalidateQueries(WALLET_OVERVIEW_DATA, {
				refetchInactive: true
			});

			await queryClient.invalidateQueries(USER_LIABILITIES, {
				refetchInactive: true
			});

			return response.data;
		},
		{
			onSuccess: () => {
				navigate(IDENTIFIED_LIABILITIES_ROUTE);
			}
		}
	);
}

export default useMutateSaveStudentLiability;
